import { render, staticRenderFns } from "./CategoriesAutocomplete.vue?vue&type=template&id=a16dd7be&"
import script from "./CategoriesAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CategoriesAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports